import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Slide7Perception() {
  const perceptions = [{
    label: 'Solving radiopharma bottlenecks',
    value: 64
  }, {
    label: 'CRO/CDMO partner needs',
    value: 67
  }, {
    label: 'Future capability needs',
    value: 67
  }];
  return <div className="flex flex-col h-full max-w-[1400px] mx-auto w-full" data-id="element-648">
      <div className="mb-12" data-id="element-649">
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-650">
          Minerva is associated with the right challenges
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-651">
          Across the perception questions, Minerva was strongly associated with
          solving the issues the market identified as important, with roughly
          64–67% giving 4–5 ratings and very low negative sentiment.
        </p>
      </div>

      <div className="bg-white rounded-3xl p-10 border border-slate-200 shadow-sm mb-8" data-id="element-652">
        <div className="flex justify-between text-sm font-medium text-slate-400 mb-6 px-4" data-id="element-653">
          <span data-id="element-654">Low Association (1-3)</span>
          <span data-id="element-655">Strong Association (4-5)</span>
        </div>

        <div className="space-y-10" data-id="element-656">
          {perceptions.map((item, i) => <div key={i} className="relative" data-id="element-657">
              <div className="flex justify-between items-end mb-3" data-id="element-658">
                <h3 className="text-lg font-bold text-slate-800" data-id="element-659">
                  {item.label}
                </h3>
                <span className="text-2xl font-bold text-minerva-blue" data-id="element-660">
                  {item.value}%
                </span>
              </div>

              <div className="h-6 bg-slate-100 rounded-full overflow-hidden flex" data-id="element-661">
                <motion.div initial={{
              width: 0
            }} animate={{
              width: `${100 - item.value}%`
            }} transition={{
              duration: 1,
              delay: 0.2 + i * 0.2
            }} className="h-full bg-slate-200" data-id="element-662" />
                <motion.div initial={{
              width: 0
            }} animate={{
              width: `${item.value}%`
            }} transition={{
              duration: 1,
              delay: 0.2 + i * 0.2
            }} className="h-full bg-gradient-to-r from-minerva-blue to-minerva-cyan relative" data-id="element-663">
                  {/* Shimmer effect */}
                  <motion.div animate={{
                x: ['-100%', '200%']
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'linear',
                delay: 1
              }} className="absolute top-0 bottom-0 w-1/2 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-664" />
                </motion.div>
              </div>
            </div>)}
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1
    }} className="bg-minerva-dark text-white rounded-2xl p-8 flex gap-6 items-center mt-auto" data-id="element-665">
        <div className="p-4 bg-white/10 rounded-full shrink-0" data-id="element-666">
          <ShieldCheck className="w-8 h-8 text-minerva-cyan" data-id="element-667" />
        </div>
        <div data-id="element-668">
          <h4 className="text-lg font-bold text-minerva-cyan mb-2" data-id="element-669">
            Strategic Interpretation
          </h4>
          <p className="text-white/90 text-lg leading-relaxed" data-id="element-670">
            The Snak did not only identify market challenges. It showed that
            Minerva has credibility and relevance in relation to those
            challenges.
          </p>
        </div>
      </motion.div>
    </div>;
}